import 'react-bootstrap-typeahead'
import { Typeahead } from 'react-bootstrap-typeahead'
import React, { useState, useEffect } from 'react'
import { Card, Form } from 'react-bootstrap'
import ApiEndpoints, { BASE_URL } from './ApiEndpoints'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import axios from 'axios'
import { excludePassedOutStudents } from '../../utils/studentFilters'

const coursesFromTeacherClasses = (payload) => {
  const raw = payload?.data ?? payload
  const list = Array.isArray(raw)
    ? raw
    : raw?.assigned_classes ?? raw?.assignedClasses ?? raw?.classes ?? []

  const courses = []
  const seen = new Set()

  ;(Array.isArray(list) ? list : []).forEach((item) => {
    const id = item?.course_id ?? item?.courseId ?? item?.course?.id
    const name =
      item?.course_name ??
      item?.courseName ??
      (typeof item?.course === 'string' ? item.course : item?.course?.name)

    if (id == null || id === '' || !name) return
    const key = String(id)
    if (seen.has(key)) return
    seen.add(key)
    courses.push({ id, name })
  })

  return courses
}

const SelectableField = ({
  onSelect,
  showStudent,
  showCourse,
  showClass,
  abc,
  setData,
  /** When true, strip passed-out students before updating table / dropdown lists (e.g. AddStudent). */
  stripPassedOut = false,
  resetTrigger,
  useTeacherClasses = false,
}) => {
  const scrub = (list) => {
    const arr = Array.isArray(list) ? list : []
    return stripPassedOut ? excludePassedOutStudents(arr) : arr
  }
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([]) // Store all students
  const [filteredStudents, setFilteredStudents] = useState([]) // Store filtered students
  const [selectedFilters, setSelectedFilters] = useState({
    course: '',
    class: '',
    student: '',
  })
  const [selectedStudentId, setSelectedStudentId] = useState('')

  useEffect(() => {
    setSelectedFilters({
      course: '',
      class: '',
      student: '',
    })
  }, [resetTrigger])
  // Fetch courses for the Select Course filter
  useEffect(() => {
    if (useTeacherClasses) {
      const userCookie = Cookies.get('user')
      let token = null
      if (userCookie) {
        try {
          token = JSON.parse(userCookie)?.token || null
        } catch (err) {
          console.error('Failed to parse user cookie', err)
        }
      }

      axios
        .get(BASE_URL + '/teacher-classes', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        })
        .then((res) => setCourses(coursesFromTeacherClasses(res.data)))
        .catch((err) => console.error('Error fetching courses:', err))
      return
    }

    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch((err) => console.error('Error fetching courses:', err))
  }, [useTeacherClasses])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        const all = scrub(response.data.data || [])
        setData(all)
        setAllStudents(all)
      } catch (error) {
        console.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  // Fetch classes based on selected course
  useEffect(() => {
    if (selectedFilters.course) {
      ApiEndpoints.getAllClassesByCourseId(selectedFilters.course)
        .then((res) => setClasses(res.data.data))
        .catch((err) => console.error('Error fetching classes:', err))
    } else {
      setClasses([])
      setFilteredStudents([]) // Reset students if no course selected
    }
  }, [selectedFilters.course])

  // Filter students based on selected class_id
  const fetchStudentsByClass = async (classId) => {
    try {
      const institueId = Cookies.get('institute_id')
      const userCookie = Cookies.get('user')
      let token = null
      if (userCookie) {
        try {
          token = JSON.parse(userCookie)?.token || null
        } catch (err) {
          console.error('Failed to parse user cookie', err)
        }
      }
      const headers = {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : undefined,
        'institute-Id': Number(institueId),
      }

      const response = await axios.get(
        BASE_URL+`/get/student/by-class?class_id=${classId}`,
        { headers },
      )

      console.log('Filtered Students from API:', response.data.data)
      setFilteredStudents(scrub(response.data.data || []))
    } catch (error) {
      console.error(
        error.response?.data?.message || 'Failed to fetch students by class.',
      )
      setFilteredStudents([]) // reset if error
    }
  }
  useEffect(() => {
    console.log('Selected Class ID:', selectedFilters.class)

    if (selectedFilters.class) {
      fetchStudentsByClass(selectedFilters.class)
    } else {
      console.log('No class selected, resetting filtered students.')
      setFilteredStudents([])
    }
  }, [selectedFilters.class])

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    setSelectedFilters({ course: courseId, class: '', student: '' })
    setClasses([])
    setFilteredStudents([])
    onSelect({ course: courseId, class: '', student: '' })
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    const instituteId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    if (userCookie) {
      try {
        token = JSON.parse(userCookie)?.token || null
      } catch (err) {
        console.error('Failed to parse user cookie', err)
      }
    }

    const headers = {
      'institute-Id': Number(instituteId),
      Authorization: token ? `Bearer ${token}` : undefined,
    }

    setSelectedFilters((prev) => ({ ...prev, class: classId, student: '' }))
    // setFilteredStudents(
    //   allStudents.filter((student) => String(student.class_id) === classId),
    // )

    if (classId) {
      // const institueId = Cookies.get('institute_id')
      // const headers = {
      //   'institute-Id': Number(institueId),
      // }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          const classStudents = scrub(res.data.data || [])
          console.log('Fetched Students by class:', classStudents)

          setFilteredStudents(classStudents) // for dropdown
          setData(classStudents) // for table

          // Notify parent with new filters
          onSelect({
            ...selectedFilters,
            class: classId,
            student: '',
          })
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setFilteredStudents([])
          setClasses([])
        })
    }

    // onSelect({ ...selectedFilters, class: classId, student: '' })
  }
  // const handleStudentChange = (e) => {
  //   const studentId = e.target.value

  //   // Find the selected student by ID from filtered students
  //   const selectedStudent = filteredStudents.find(
  //     (student) => student.id === Number(studentId),
  //   )

  //   console.log('Selected Student:', selectedStudent) // Debugging

  //   setSelectedFilters((prev) => ({
  //     ...prev,
  //     student: studentId,
  //   }))

  //   // Pass the full student data to setData
  //   if (selectedStudent) {
  //     // setData(selectedStudent)
  //     onSelect({ ...selectedFilters, studentId: studentId })
  //   } else {
  //     // setData(null)
  //     onSelect({ ...selectedFilters, student: studentId })
  //   }
  // }
  const handleStudentChange = (e) => {
    const studentId = e.target.value
    console.log('studentId:', studentId)
    setSelectedStudentId(studentId)
    const selectedStudent = filteredStudents.find(
      (student) => student.id === Number(studentId),
    )

    console.log('selectedStudent:', selectedStudent)

    const updatedFilters = {
      ...selectedFilters,
      student: studentId,
    }

    setSelectedFilters(updatedFilters)

    if (onSelect) {
      onSelect(updatedFilters)
      console.log('After onSelect:', updatedFilters)
    }
  }

  return (
    <Card className="p-0 mt-2 border-0 text-start container">
      <style>
        {`
          .selectable-field-label {
            font-size: 13px !important;
            font-weight: 600;
            margin-bottom: 6px;
            color: #475569;
          }
          
          .selectable-field-typeahead .rbt-input-main {
            height: 36px !important;
            font-size: 13px !important;
            padding: 6px 12px !important;
            border-radius: 0px !important;
            // border: 2px solid gray !important;
            background-color: white !important;
          }
          
          .selectable-field-typeahead .rbt-input-main:focus {
            // border-color: gray !important;
            box-shadow: 0 0 0 3px rgba(255, 178, 178, 0.15) !important;
            outline: none !important;
          }
          
          .selectable-field-typeahead .rbt-input-hint {
            height: 36px !important;
            font-size: 13px !important;
            padding: 6px 12px !important;
          }
          
          .selectable-field-typeahead .rbt-menu {
            font-size: 13px !important;
            max-height: 200px !important;
          }
          
          .selectable-field-typeahead .rbt-menu .dropdown-item {
            padding: 8px 12px !important;
            font-size: 13px !important;
          }
        `}
      </style>
      <div className="row g-2 align-items-start">
        {showCourse && (
          <div className="col-12 col-md-4">
            <Form.Group className="mb-2 text-start">
              <Form.Label className="selectable-field-label">Select Course</Form.Label>
              <div className="selectable-field-typeahead">
                <Typeahead
                  id="course-select"
                  labelKey="name"
                  onChange={(selected) => {
                    const course = selected[0]
                    if (course) {
                      handleCourseChange({ target: { value: course.id } })
                    } else {
                      handleCourseChange({ target: { value: '' } })
                    }
                  }}
                  options={courses}
                  placeholder="Select Course"
                  selected={courses.filter(
                    (course) => course.id === Number(selectedFilters.course),
                  )}
                />
              </div>
            </Form.Group>
          </div>
        )}
        {showClass && (
          <div className="col-12 col-md-4">
            <Form.Group className="mb-2 text-start">
              <Form.Label className="selectable-field-label">Select Class</Form.Label>
              <div className="selectable-field-typeahead">
                <Typeahead
                  id="class-select"
                  labelKey="class_name"
                  onChange={(selected) => {
                    const cls = selected[0]
                    if (cls) {
                      handleClassChange({ target: { value: cls.id } })
                    } else {
                      handleClassChange({ target: { value: '' } })
                    }
                  }}
                  options={classes}
                  placeholder="Select Class"
                  selected={classes.filter(
                    (cls) => cls.id === Number(selectedFilters.class),
                  )}
                />
              </div>
            </Form.Group>
          </div>
        )}
        {showStudent && (
          <div className="col-12 col-md-4">
            <Form.Group className="mb-2 text-start">
              <Form.Label className="selectable-field-label">Select Student</Form.Label>
              <div className="selectable-field-typeahead">
                <Typeahead
                  id="student-select"
                  labelKey={(student) =>
                    `${student.name} - ${student.admission_number}`
                  }
                  onChange={(selected) => {
                    const student = selected[0]
                    if (student) {
                      handleStudentChange({ target: { value: student.id } })
                    } else {
                      handleStudentChange({ target: { value: '' } })
                    }
                  }}
                  options={filteredStudents}
                  placeholder="Select Student"
                  selected={filteredStudents.filter(
                    (std) => std.id === Number(selectedFilters.student),
                  )}
                />
              </div>
            </Form.Group>
          </div>
        )}
      </div>
    </Card>
  )
}

export default SelectableField
